<template>
  <div class="space">
    <div class="nav" :id="'nav-' + index" v-for="(item, index) in navList" :key="index" @click="goNav(item)">
      <!-- {{ item.name }} -->
      <img v-if="item.name == '云课堂' " style="width: 100%; height: 100%;" src="~@/common/img/space1.png" alt="云课堂" />
      <img v-else-if="item.name == '云直播' " style="width: 100%; height: 100%;" src="~@/common/img/space2.png" alt="云直播" />
      <img v-else-if="item.name == '云双师' " style="width: 100%; height: 100%;" src="~@/common/img/space3.png" alt="云双师" />
      <img v-else-if="item.name == '云教研' " style="width: 100%; height: 100%;" src="~@/common/img/space4.png" alt="云教研" />
      <img v-else-if="item.name == '云巡课' " style="width: 100%; height: 100%;" src="~@/common/img/space5.png" alt="云巡课" />
      <img v-else style="width: 100%; height: 100%;" src="~@/common/img/space0.png" alt="未知" />
      <div class="tag-box" v-if="item.path == '暂无' ">敬请期待</div>
    </div>
  </div>
</template>

<script>
import Api from "@/api/base";
import { getStorage } from "@/common/js/localstorage";

export default {
  data() {
    return {
      orgId: 0,
      orgType: 1,
      navList: [
        //以下空间菜单由接口（/base/navigation_list）获取
        //老师
        // {
        //   id: 1, //无所谓
        //   name: "云课堂",
        //   path: "/micro/live/my_live_list?live_type=2"
        // },
        // {
        //   id: 2,
        //   name: "云直播",
        //   path: "/micro/live/my_live_list?live_type=1"
        // },
        // {
        //   id: 3,
        //   name: "云双师",
        //   path: ""
        // },
        // {
        //   id: 4,
        //   name: "云教研",
        //   path: ""
        // },
        // {
        //   id: 5,
        //   name: "云巡课",
        //   path: ""
        // },
        // //学生
        // {
        //   id: 1,
        //   name: "云课堂",
        //   path: "/micro/live?live_type=2"
        // },
        // {
        //   id: 2,
        //   name: "云直播",
        //   path: "/micro/live?live_type=1"
        // },
      ],
    };
  },
  created() {
    // window.open("/space/", "_self");
    this.getSchoolId();
  },
  methods: {
    // 先判断是否登录，再判断区域用户还是学校用户，并设置school_id
    getSchoolId() {
      if (getStorage("user")) {
        let data = getStorage("user");
        if (data.identity == 1) {
          window.open("/space/", "_self");
          return
        } else {
          //判断
          if (data.org_web_path == "" || data.org_web_path == "/") {
            //跳转到区域根目录
            window.open("/", "_self");
          } else if ((data.org_web_path.includes("http://") || data.org_web_path.includes("https://"))) {
            //跳转到指定 org_web_path
            window.open(data.org_web_path, "_self");
          } else {
            let userPath = data.org_web_path + "/";
            window.open(userPath, "_self");
          }
          // this.$router.push({
          //   path: "/home",
          // });
          return
        }

        // let orgWebPath = new URL(data.org_web_path)
        // if (window.location.pathname == "/" && orgWebPath.pathname != "/") {
        //   let userPath = data.org_web_path + "/";
        //   window.open(userPath, "_self");
        // }

        // if (data.area_type == 2) {
        //   this.orgId = data.area_id;
        //   this.orgType = 2;
        //   let tempData = {
        //     school_id: this.orgId,
        //   };
        //   this.getNavList(tempData);
        // } else {
        //   this.orgId = data.area_id;
        //   this.orgType = 1;
        //   let tempData = {
        //     area_id: this.orgId,
        //   };
        //   this.getNavList(tempData);
        // }
        // this.$bus.$emit("showHeaderAndFooter", true);
      } else {
        window.open(window.location.origin + "/#/login", "_self");
      }
    },
    getNavList(data) {
      Api.getSpaceNavigationList(data).then((response) => {
        if (response.data.status === 0) {
          this.navList = response.data.data.list;
          // for (let i = 0; i < this.navList.length; i++) {
          //   if (this.navList[i].path == "/manage/#/new_home") {
          //     this.navList.splice(i, 1);
          //   }
          // }
        }
      });
    },
    goNav(item) {
      if (item.path != "暂无" && item.path != "") {
        this.$router.push({
          path: item.path,
        });
      } else {
        this.$message.success({
          message: "敬请期待",
          duration: 1000,
        });
      }
      // if (item.path.includes("/manage")) {
      //   window.open(item.path, "_self");
      // } else if (item.path.includes("/micro/supervision")) {
      //   console.log("需要发送关闭通知");
      //   // this.$bus.$emit("showHeaderAndFooter", false);
      //   this.$router.push({
      //     path: item.path,
      //   });
      // } else {
      //   this.$router.push({
      //     path: item.path,
      //   });
      // }
    },
  },
};
</script>

<style scoped lang="stylus">
.space {
  width: 90vw;
  height: calc(100vh - 270px);
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  margin: 0 auto;
  margin-top: 70px;

  .nav {
    height: 40vh;
    cursor: pointer;
    position: relative;

    .tag-box {
      position: absolute;
      top: 36px;
      right: 37px;
      width: 80px;
      line-height: 20px;
      background-color: #DCDFE6;
      color: #E6A23C;
      border-radius: 4px;
    }
  }

  .nav:hover {
    opacity: 0.9;
    transform: scale(1.1);
  }

  @media screen and (max-width: 420px) {
    .nav {
      width: 90vw;
      margin: 10px 5px;
      font-size: 16px;
      border-radius: 10px;
    }
  }
}
</style>